import Cookies from 'universal-cookie';
import { navigate } from 'gatsby';

export const clearContext = (globalContext: any, sessionTimerContext: any) => {
  globalContext?.setToken('');
  globalContext?.setUsername('');
  globalContext?.setTenantId('');
  globalContext?.setTokenExpiry('');
  globalContext?.setTenantSearchResponse([]);
  globalContext?.setSelectedLocationName('');
  globalContext?.setCurrSessionTime('');
  globalContext?.setTenantName('');
  globalContext?.setLoggedInSmsFacilityId('');
  if (sessionTimerContext) {
    sessionTimerContext?.setSessionExpiryTime('');
  }
};

export const clearCookies = () => {
  const cookies = new Cookies();
  cookies.remove('cToken');
  cookies.remove('cUserName');
  cookies.remove('cTokenExpiry');
  cookies.remove('cTenantId');
  cookies.remove('cFacilityId');
  cookies.remove('cSelectedLocationName');
  cookies.remove('cExpiryTime');
  cookies.remove('isTenantUpdated');
  cookies.remove('isNewTenant');
  cookies.remove('newLedgerId');
  cookies.remove('cTenantName');
};

export const logOutUser = (showSessionExpiredWarning = false) => {
  const pathName = location.pathname;
  if (pathName.includes('account-selection')) {
    navigate('../login', {
      replace: true,
      state: {
        sessionExpired: showSessionExpiredWarning,
      },
    });
  } else {
    navigate('/', {
      replace: true,
      state: {
        sessionExpired: showSessionExpiredWarning,
      },
    });
  }
};
